/**
 * Module dependencies.
 */

import { SupportDownloadCategory } from 'src/types/downloads';

/**
 * Export `supportPrograms`.
 */

export const supportPrograms: SupportDownloadCategory[] = [
  {
    downloads: [
      {
        name: 'support-programs:labels.scba',
        size: 105269,
        url: '/static/pdfs/tank-for-self-contained-breathing-apparatus-scba.pdf'
      },
      {
        name: 'support-programs:labels.xLiteNewGeneration',
        size: 112608,
        url: '/static/pdfs/1505906032-amtrol-p2020-ficha-de-projeto-x-lite.pdf'
      },
      {
        name: 'support-programs:labels.amtrolQualifica',
        size: 89315,
        url: '/static/pdfs/projeto-autonomo-de-formacao-amtrol-qualifica.pdf'
      }
    ],
    name: 'support-programs:labels.projects'
  }
];
